import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
// import { Tooltip } from 'antd';
// import styled from '@emotion/styled';
// import Button from '../../common/Button';
import Dropdown from '../../common/Dropdown';
// import Input from '../../common/Input';
import { SelectWrapper, SelectLabel } from './styled';
import Checkout from '../../Checkout';
import CommonButton from '../../../components/common/Button';
import IconSvg from '../../../components/common/IconSvg';

const { Option } = Dropdown;

// const CustomInput = styled(Input)`
//   font-size: ${({ theme }) => theme.fontSize.small};
// `;

@injectIntl
class ThirdPartyConnect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: '',
      loading: false,
    };
    this.handleTypeChange = this.handleTypeChange.bind(this);
    this.breadcrumb = {
      name: props.intl.formatMessage({ id: 'settingsModal.connectThirdParty' }),
    };
  }
  componentDidMount() {
    this.props.updateBreadcrumbs(this.breadcrumb, false);
  }
  handleTypeChange(value) {
    this.setState({ type: value });
  }

  render() {
    const { intl, closeForm, connectPayoneerAccount, connectStripeAccount } = this.props;
    const { loading, type } = this.state;
    const isButtonDisabled = type === '';
    return (
      <div style={{ marginTop: '1em' }}>
        {loading && <div className="loader" />}
        <SelectWrapper>
          <SelectLabel>
            <span>1.</span>
            {intl.formatMessage({ id: 'connection.thirdPartyType' })}
          </SelectLabel>
          <Dropdown width="150px" onChange={this.handleTypeChange}>
            {/* <Option key="paypal" value="paypal">
              Paypal
            </Option> */}
            <Option key="payoneer" value="payoneer">
              Payoneer
            </Option>
            {/* <Option key="stripe" value="stripe" disabled>
              <Tooltip title="Credit card payments are temporarily disabled.">Credit Card</Tooltip>
            </Option> */}
          </Dropdown>
        </SelectWrapper>
        {!isButtonDisabled && type === 'paypal' && (
          <Checkout
            beforeConnect={() => {
              this.setState({
                loading: true,
              });
            }}
            afterConnect={() => {
              this.setState(
                {
                  loading: false,
                },
                closeForm,
              );
            }}
          />
        )}
        {!isButtonDisabled && type === 'payoneer' && (
          <div
            css={css`
              display: flex;
              align-items: cener;
              justify-content: center;
            `}
          >
            <CommonButton
              cssProps={{
                padding: 'padding: 0 20px',
                borderRadius: '20px',
                marginBottom: '5px',
                marginLeft: '5px',
              }}
              size="large"
              type="primary"
              clickHandler={connectPayoneerAccount}
              disabled={false}
            >
              <FormattedMessage id="balance.loadViaPayoneer" />
              <IconSvg type="payoneer" size="20" marginLeft="5px" />
            </CommonButton>
          </div>
        )}
        {!isButtonDisabled && type === 'stripe' && (
          <div
            css={css`
              display: flex;
              align-items: cener;
              justify-content: center;
            `}
          >
            <CommonButton
              cssProps={{
                padding: 'padding: 0 20px',
                borderRadius: '20px',
                marginBottom: '5px',
                marginLeft: '5px',
              }}
              size="large"
              type="primary"
              clickHandler={connectStripeAccount}
              disabled={false}
            >
              <FormattedMessage id="balance.loadViaStripe" />
            </CommonButton>
          </div>
        )}
      </div>
    );
  }
}

ThirdPartyConnect.propTypes = {
  intl: PropTypes.object,
  updateBreadcrumbs: PropTypes.func,
  closeForm: PropTypes.func,
};

export default ThirdPartyConnect;
